var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<redi-window-frame>\n<div ng-controller=\"WindowController as that\" style=\"position: absolute; top: 0; left: 0; bottom: 0; right: 0;\">\n<iframe id=\"window-container\" ng-if=\"that.url\" src=\"{{ that.url | trustAsResourceUrl }}\" style=\"width: 100%; height: 100%; border: 0;\">\n</iframe>\n</div>\n</redi-window-frame>\n";
var id1="views/window.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ../partials/views/window.html
// module id = 144
// module chunks = 0